import React from "react"
import CsvDownload from "../../CSV Download/csvDownload"
import TableFilter from "../../Filter/table_filter"

import barStyles from './top_bar.module.scss'

const TopTableBar = ({tableData, fileName, ignores=[], filters}) => {

    if (filters) {
        
        return (
            <div className={barStyles.topBar}>
                <CsvDownload
                    tableData={tableData}
                    ignores={ignores}
                    fileName={fileName}
                />
                <TableFilter
                    filters={filters}
                />
            </div>
        )
    
    } else {

        return (
            <div className={barStyles.topBar}>
                <CsvDownload
                    tableData={tableData}
                    ignores={ignores}
                    fileName={fileName}
                />
            </div>
        )       
    
    }

}

export default TopTableBar